import React, { useRef } from 'react';
import * as Styles from './Authentication.style';
import { Trans, useTranslation } from 'react-i18next';
import { Highlight } from 'components/vm-deployment/components';
import { Grid, useMediaQuery } from '@mui/material';
import { Formik, Form } from 'formik';
import {
  backupFormInitialValues,
  backupFormValidationSchema,
  primaryFormInitialValues,
  primaryFormValidationSchema,
} from 'constants/account-profile';
import { Heading } from 'components/user-management/Heading';
import { P } from 'components/reusable-css';
import ErrorMessage from 'components/common/red-notification';
import PinInput from 'react-pin-input';
import PrimaryForm from './PrimaryForm';
import BackupForm from './BackupForm';

const Authentication = ({ areaCodeData, get2fadata }) => {
  const primaryRef = useRef(null);
  const backupRef = useRef(null);
  const { t } = useTranslation();
  const mobile = useMediaQuery('(max-width:500px)');

  const handlePrimarySubmit = async () => {};

  const handleBackupSubmit = async () => {};

  const handlePrimaryVerify = async () => {};

  const handleBackupVerify = async () => {};

  const areaCodeArr = areaCodeData?.two_fa_codes?.map((val) => {
    return { value: val.id.split('+')[1], text: val.id };
  });

  return (
    <Styles.PassSC>
      <Styles.Pass>
        <Heading>
          <Trans i18nKey="account/profile.string9" components={{ highlight: <Highlight /> }} />
        </Heading>
        <Styles.ChangePasswords>
          <P>{t('account/profile.string10')}</P>
          <P>{t('account/profile.string11')}</P>
          <Styles.FormDiv>
            <Grid container>
              <Grid xs={12} sm={12} md={4} lg={3} xl={2}>
                <Styles.Label>{t('account/profile.string12')}</Styles.Label>
              </Grid>
              <Grid>
                <div className="flexColumn">
                  <Formik
                    initialValues={primaryFormInitialValues(get2fadata, areaCodeArr)}
                    validationSchema={primaryFormValidationSchema}
                    onSubmit={(values) => handlePrimarySubmit(values)}
                  >
                    {(formikProps) => (
                      <Form>
                        <PrimaryForm
                          mobile={mobile}
                          isLoading={false}
                          get2fadata={get2fadata}
                          areaCodeArr={areaCodeArr}
                          formikProps={formikProps}
                        />
                      </Form>
                    )}
                  </Formik>
                  <Styles.VerificationFom display={0} visible={0}>
                    <Styles.PinSC>
                      <PinInput
                        ref={primaryRef}
                        length={6}
                        initialValue=""
                        type="numeric"
                        inputMode="number"
                        style={{ padding: '10px 0px' }}
                        inputStyle={{
                          width: mobile ? '38px' : '50px',
                          height: '50px',
                          border: '2px solid #b3b3b3b3',
                          borderBottom: '2.9px solid orange',
                          background: 'white',
                          marginLeft: '5px',
                          marginBottom: '5px',
                          fontSize: '22px',
                        }}
                        onComplete={(value) => {
                          handlePrimaryVerify(value);
                        }}
                        autoSelect
                        focus
                        regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                      />
                    </Styles.PinSC>

                    <div style={{ padding: '0 3.1em' }} />
                  </Styles.VerificationFom>
                </div>
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={12} sm={12} md={4} lg={3} xl={2}>
                <Styles.Label>{t('account/profile.string13')}</Styles.Label>
              </Grid>
              <Grid>
                <Formik
                  initialValues={backupFormInitialValues(get2fadata, areaCodeArr)}
                  validationSchema={backupFormValidationSchema}
                  onSubmit={(values) => handleBackupSubmit(values)}
                >
                  {(formikProps) => (
                    <Form>
                      <BackupForm
                        mobile={mobile}
                        get2fadata={get2fadata}
                        formikProps={formikProps}
                        areaCodeArr={areaCodeArr}
                        isLoading={false}
                      />
                    </Form>
                  )}
                </Formik>
                <Styles.VerificationFom visible={0} display={0}>
                  <Styles.PinSC>
                    <PinInput
                      ref={backupRef}
                      length={6}
                      initialValue=""
                      type="numeric"
                      inputMode="number"
                      style={{ padding: '10px 0px' }}
                      inputStyle={{
                        width: mobile ? '38px' : '50px',
                        height: '50px',
                        border: '2px solid #b3b3b3b3',
                        borderBottom: '2.9px solid orange',
                        background: 'white',
                        marginLeft: '5px',
                        marginBottom: '5px',
                        fontSize: '22px',
                      }}
                      onComplete={(value) => {
                        handleBackupVerify(value);
                      }}
                      autoSelect
                      focus
                      regexCriteria={/^[ A-Za-z0-9_@./#&+-]*$/}
                    />
                  </Styles.PinSC>

                  <div style={{ padding: '0 3.1em' }} />
                </Styles.VerificationFom>
              </Grid>
            </Grid>
          </Styles.FormDiv>
        </Styles.ChangePasswords>
        <Styles.Warning>
          <ErrorMessage bgColor="#82bf50">
            <p>{t('account/profile.string14')}</p>
          </ErrorMessage>
        </Styles.Warning>
      </Styles.Pass>
    </Styles.PassSC>
  );
};
export default Authentication;
